import { render, staticRenderFns } from "./OfficeSettingsForm.vue?vue&type=template&id=6d911981&scoped=true"
import script from "./OfficeSettingsForm.vue?vue&type=script&lang=ts"
export * from "./OfficeSettingsForm.vue?vue&type=script&lang=ts"
import style0 from "./OfficeSettingsForm.vue?vue&type=style&index=0&id=6d911981&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d911981",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d911981')) {
      api.createRecord('6d911981', component.options)
    } else {
      api.reload('6d911981', component.options)
    }
    module.hot.accept("./OfficeSettingsForm.vue?vue&type=template&id=6d911981&scoped=true", function () {
      api.rerender('6d911981', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/OfficeSettingsForm/OfficeSettingsForm.vue"
export default component.exports